import type { IDataSource } from "@/data/dao/service/BaseServiceDao";
import { PrintWhenOrderHasStatus } from "@/data/model/Enums";
import { Misc } from "@/data/util/Misc";



import { i18n } from "@/portal/Trans";
import { Select } from "@/portal/formControls/Select";


export class PrintWhenOrderHasStatusesSelect {
    private allowedPrintWhenOrderHasStatus: PrintWhenOrderHasStatus;
    private PrintWhenOrderHasStatusSelect: Select<PrintWhenOrderHasStatus>;

    constructor($element: JQuery) {
        this.allowedPrintWhenOrderHasStatus =
            PrintWhenOrderHasStatus.Confirmed |
            PrintWhenOrderHasStatus.Ready;

        const datasource: IDataSource<PrintWhenOrderHasStatus> = {
            getData: this.getOptions.bind(this),
        };

        this.PrintWhenOrderHasStatusSelect = new Select(
            $element,
            datasource,
            undefined,
            false,
            i18n(`enums.PrintWhenOrderHasStatus.${PrintWhenOrderHasStatus[PrintWhenOrderHasStatus.None]}`),
            undefined,
            true
        ) as Select<PrintWhenOrderHasStatus>;
    }

    public setValues(printWhenOrderHasStatuses: PrintWhenOrderHasStatus | undefined) {
        const selectedValues: number[] = [];
        if (printWhenOrderHasStatuses !== undefined) {
            Misc.eachEnum(PrintWhenOrderHasStatus, (id) => {
                if (id == 0) return;
                if ((printWhenOrderHasStatuses & id) === id) {
                    selectedValues.push(id);
                }
            });
        }

        this.PrintWhenOrderHasStatusSelect.setValues(selectedValues);
    }

    public setAllowedOptions(allowedEndUserProperties: PrintWhenOrderHasStatus | undefined) {
        this.allowedPrintWhenOrderHasStatus = allowedEndUserProperties ?? PrintWhenOrderHasStatus.None;
        this.PrintWhenOrderHasStatusSelect.fetchData();
    }

    public getValue(): PrintWhenOrderHasStatus {
        // Initialize the sum of the enum values.
        let enumValuesSum = PrintWhenOrderHasStatus.None;

        // Retrieve the selected values from the select component. If no values are selected, default to an empty array.
        const selectedValues = this.PrintWhenOrderHasStatusSelect.getValues() ?? [];

        // Iterate over the selected values, parse each one to an integer, and add it to the sum.
        selectedValues.forEach((value) => {
            enumValuesSum += parseInt(value);
        });

        // Return the sum of the selected enum values.
        return enumValuesSum;
    }

    private async getOptions() {
        const availableOptions: any[] = [];

        Misc.eachEnum(PrintWhenOrderHasStatus, (id, enumValName) => {
            if (id == 0) return;

            if ((this.allowedPrintWhenOrderHasStatus & id) !== id) return;

            availableOptions.push({
                id: id,
                name: i18n(`enums.PrintWhenOrderHasStatus.${enumValName}`),
            });
        });

        return {
            items: availableOptions,
            limit: 0,
            offset: 0,
            hasNext: false,
            hasPrev: false,
        };
    }
}
